import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AnnatureAccountModel } from "@models/annature/annature-account-model";
import { AnnatureConnection } from "@models/annature/annature-connection";
import { AnnatureRegisterAccount } from "@models/annature/annature-register-account";
import { ConnectionStatusEnum } from "@models/integrations/connection-status.enum";
import { ConnectionResponse } from "@models/integrations/integration-connection-response";
import { IntegrationConnectionsEnum } from "@models/integrations/integration-connections.enum";
import BaseApiService from "@shared/services/base/base-api.service";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class IntegrationsApiService extends BaseApiService {
  connect(connectionType: IntegrationConnectionsEnum): Observable<string> {
    return this.api.get(`${ this.apiUrl }/integrations/${ connectionType }/connect`, { responseType: 'text' });
  }

  connectByKeys(connectionType: IntegrationConnectionsEnum, data: AnnatureConnection): Observable<ConnectionStatusEnum> {
    return this.api.post<ConnectionStatusEnum>(`${ this.apiUrl }/integrations/${ connectionType }/connect`, data);
  }

  registerAnnatureAccount(data: AnnatureRegisterAccount): Observable<ConnectionResponse> {
    return this.api.post<ConnectionResponse>(`${ this.apiUrl }/integrations/annature/register`, data);
  }

  resendVerificationAnnature(): Observable<string> {
    return this.api.post<string>(`${ this.apiUrl }/integrations/annature/account/resend-verification`, null);
  }

  getAnnatureAccountList(): Observable<AnnatureAccountModel[]> {
    return this.api.get<AnnatureAccountModel[]>(`${ this.apiUrl }/integrations/annature/accounts`);
  }

  setAnnatureAccount(model: AnnatureAccountModel): Observable<ConnectionStatusEnum> {
    return this.api.put<ConnectionStatusEnum>(`${ this.apiUrl }/integrations/annature/account`, model);
  }

  disconnect(connectionType: IntegrationConnectionsEnum): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/integrations/${ connectionType }/disconnect`, null);
  }

  checkConnection(connectionType: IntegrationConnectionsEnum): Observable<ConnectionResponse> {
    return this.api.get<ConnectionResponse>(`${ this.apiUrl }/integrations/${ connectionType }/check`);
  }

  processCallback(connectionType: IntegrationConnectionsEnum, state: string, code: string): Observable<boolean> {
    let params = new HttpParams();

    params = params.append('state', state);
    params = params.append('code', code);

    return this.api.get<boolean>(`${ this.apiUrl }/integrations/${ connectionType }/callback`, { params: params });
  }

}
